import { getJsonList, setJsonList } from "lib/storage/local-storage";

const BOOKMARKS_KEY = "fb-reader-bookmarks";

type LocalBookmark = {
  id: string;
  artId: number;
  created_at: string;
  xpointer: string;
  percent: number;
  version: number;
  is_epub: boolean;
  chapter_title: string;
};

export function getLocalBookmarks(artId: number): LocalBookmark[] {
  const all = getJsonList<LocalBookmark>(BOOKMARKS_KEY);
  return all.filter(b => b.artId === artId);
}

export function addLocalBookmark(
  bookmark: Omit<LocalBookmark, "artId">,
  artId: number
): void {
  const all = getJsonList<LocalBookmark>(BOOKMARKS_KEY);
  const filtered = all.filter(b => b.id !== bookmark.id);
  filtered.push({ ...bookmark, artId });
  setJsonList(BOOKMARKS_KEY, filtered);
}

export function deleteLocalBookmark(bookmarkId: string): void {
  const all = getJsonList<LocalBookmark>(BOOKMARKS_KEY);
  const filtered = all.filter(b => b.id !== bookmarkId);
  setJsonList(BOOKMARKS_KEY, filtered);
}
